import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: 'الرئيسية', icon: '🏠' },
  { path: '/about', label: 'من نحن', icon: '🏢' },
  { path: '/support', label: 'الدعم', icon: '🛟' },
  { path: '/terms', label: 'الشروط والسياسة', icon: '📋' },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
        <div className="container">
          <div className="navbar-inner">
            {/* Logo */}
            <Link to="/" className="navbar-logo">
              <img src="/logo.png" alt="استراحة شاشتنا" className="navbar-logo-icon" />
              <div className="navbar-logo-text">
                <span className="navbar-logo-name">استراحة شاشتنا</span>
                <span className="navbar-logo-tagline">
                  منصة الترفيه المحلية
                </span>
              </div>
            </Link>

            {/* Desktop Nav */}
            <ul className="navbar-nav">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className={`nav-link ${
                      location.pathname === link.path ? 'active' : ''
                    }`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* CTA + Hamburger */}
            <div className="navbar-actions">
              <a
                href="https://wa.me/967783124226"
                target="_blank"
                rel="noopener noreferrer"
                className="navbar-cta"
              >
                <span>💬</span>
                <span>تواصل معنا</span>
              </a>

              {/* Hamburger */}
              <button
                className="navbar-hamburger"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="القائمة"
              >
                <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
                <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
                <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={`mobile-overlay ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        {navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`mobile-nav-link ${
              location.pathname === link.path ? 'active' : ''
            }`}
            onClick={() => setMenuOpen(false)}
          >
            <span className="mobile-nav-icon">{link.icon}</span>
            {link.label}
          </Link>
        ))}
        <a
          href="https://wa.me/967783124226"
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-cta"
        >
          <span>💬</span>
          <span>تواصل عبر واتساب</span>
        </a>
      </div>
    </>
  );
}

export default Navbar;